<template>
  <div>
    <v-tabs background-color="transparent" color="basil">
      <v-tab to="/import">Import</v-tab>
      <v-tab to="/import/activities">Activities</v-tab>
    </v-tabs>

    <keep-alive >
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Import-Uhive"
  }
};
</script>

<style>
</style>